import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("ec_cookie_consent")) setVisible(true);
  }, []);
  const accept = (val) => {
    localStorage.setItem("ec_cookie_consent", val);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div data-testid="cookie-consent" className="fixed bottom-0 inset-x-0 z-[60] p-4">
      <div className="max-w-4xl mx-auto bg-[#0A0A0A]/95 backdrop-blur-xl border border-white/15 rounded-sm p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4 shadow-2xl">
        <Cookie size={22} className="text-[#D4AF37] shrink-0" />
        <p className="text-xs md:text-sm text-white/70 flex-1">
          Usamos cookies propias y de terceros para mejorar tu experiencia y analizar el tráfico. Consulta nuestra{" "}
          <Link to="/cookies" className="text-[#D4AF37] underline">política de cookies</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button data-testid="cookie-reject" onClick={() => accept("rejected")} className="btn-outline-gold rounded-sm px-5 py-2 text-xs">
            Rechazar
          </button>
          <button data-testid="cookie-accept" onClick={() => accept("accepted")} className="btn-gold rounded-sm px-5 py-2 text-xs">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
